import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  IconButton,
  Typography,
  TextField,
  useMediaQuery,
  Modal,
  Divider,
  Tooltip,
} from "@mui/material";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";

import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import CloseIcon from "@mui/icons-material/Close";
import ShareIcon from "@mui/icons-material/Share";
import Popover from "@mui/material/Popover";

import logo from "../../assets/images/logoman.png";
import PostDetalPage from "../popUp/PostDetailPage";
import { EmojiEmotions, MoreVertOutlined } from "@mui/icons-material";
import CustomPopover from "../popUp/CustomPopOver";
import CustomConfirmation from "../popUp/CustomConfirmation";
import { enqueueSnackbar } from "notistack";
import EmojiPicker from "emoji-picker-react";
import {
  htmlDecode,
  is_small_screen,
  show_proper_words,
} from "../../utils/Constant";
import moment from "moment";
import MainPart from "../../pages/post/MainPartPosr";
import CreatePost from "../../pages/post/CreatePost";
import { s3baseUri, project_mode } from "../../config/config";
import FeedImagesList from "../../pages/post/PostImageList";
import ReactVideoPlayer from "../player/ReactVideoPlayer";
import {
  add_feed_comment,
  delete_comment_api,
  delete_feed_action,
  get_feeds_list,
  like_feed_api,
  like_unlike_feed_comment,
  update_feed_comment,
} from "../../DAL/partner/partners";
import { useIds } from "../../hook/AdminContext";
import {
  csvImage,
  docImage,
  pdfImage,
  wordImage,
  audioImage,
  xlsxImage,
  otherImage,
} from "../../assets";
import LinkPreview from "../previewUrl/PreviewsUrl";
import PreviewPostCard from "../previewUrl/LinkPreviewPostCard";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import RecordNoImage from "../recordNotFound/RecordNoImage";
import CustomPopoverNew from "../CustomPopoverNew";
import SharePostPopup from "./SharePostPopup";

const PostCard = ({
  post,
  handleSelectedImage,

  getFeedsListingOnDelete,
  handleFeedEdit,
  selectedIndex,
  setSelectedIndex,
  previewLink,
  setPreviewLink,
  type,
}) => {
  const { userInfo, ids, findId } = useIds();
  const [liked, setLiked] = useState(false);
  const [likedComment, setLikedComment] = useState(false);
  const [preview, setPreview] = useState(null);
  const [likeCount, setLikeCount] = useState(post?.liked_by?.length);
  const [commentCount, setCommentCount] = useState(post?.comment_count);
  const [companyModalOpen, setCompanyModalOpen] = useState(false);
  const [companyModalData, setCompanyModalData] = useState(null);
  const [expanded, setExpanded] = useState(false);

  const extractURL = (str) => {
    const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+\.[^\s]{2,})/gi;
    const match = str?.match(urlRegex);

    if (!match) return null;

    const url = match[0];
    return url.startsWith("www.") ? `https://${url}` : url;
  };
  const linkInDescription = extractURL(post?.description);

  const [comments, setComments] = useState(post?.top_comments);
  const [commentsLikeCount, setCommentsLikeCount] = useState(0);
  const [commentText, setCommentText] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [showCommentBox, setShowCommentBox] = useState(false);
  const [isLoadingCom, setIsLoadingCom] = useState(false);
  const [open, setOpen] = useState(false);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [commentDialogue, setCommentDialogue] = useState(false);
  const [emojiPickerVisible, setEmojiPickerVisible] = useState(false);
  const [openDeleteComment, setOpenDeleteComment] = useState(false);
  const [selectedComment, setSelectedComment] = useState({});
  const [comment, setComment] = useState("");
  const [isEditing, setIsEditing] = useState(false); // Track if we're editing
  const [editingCommentIndex, setEditingCommentIndex] = useState(null);
  const [file, setFile] = useState("");
  const [feedComments, setFeedComments] = useState([]);
  const [openSharePost, setOpenSharePost] = useState(false);
  const [sharePostData, setSharePostData] = useState({});

  const handleLikeComment = async (comment, index) => {
    console.log(index, "indexindexindexindex");
    console.log(comment, "commentcommentcomment");
    const isLiked = likedComment[index];

    setLikedComment((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));

    setCommentsLikeCount((prev) => ({
      ...prev,
      [index]: (prev[index] || 0) + (isLiked ? -1 : 1),
    }));

    const result = await like_unlike_feed_comment(comment._id);
    console.log(result, "resultresultresultresultresultresultresult");
    if (result.code === 200) {
      setComments((prevComments) =>
        prevComments.map((comment) =>
          comment._id === result?.feed_comment?._id
            ? result?.feed_comment
            : comment
        )
      );
      const newLikeCount = result.feed_comment.liked_by.length;

      const isLikedByCurrentUser = result.feed_comment.liked_by.some(
        (user) => user._id === userInfo.user_id._id
      );

      setCommentsLikeCount((prev) => ({
        ...prev,
        [index]: newLikeCount,
      }));

      setLikedComment((prev) => ({
        ...prev,
        [index]: isLikedByCurrentUser,
      }));
    } else {
      setLikedComment((prev) => ({
        ...prev,
        [index]: isLiked,
      }));

      setCommentsLikeCount((prev) => ({
        ...prev,
        [index]: Math.max(0, prev[index] + (isLiked ? 1 : -1)),
      }));
    }
  };

  const handleLike = async () => {
    setLiked(!liked);
    setLikeCount(liked ? likeCount - 1 : likeCount + 1);
    const result = await like_feed_api(post._id);
    if (result.code === 200) {
    }
  };

  const handleCommentToggle = () => {
    setIsEditing(false);
    setCommentText("");
    setPreview(null);
    setShowCommentBox(!showCommentBox);
  };

  const handleCommentSubmit = async (event) => {
    event.preventDefault();
    if (!commentText.trim() && !preview) {
      enqueueSnackbar("Comment cannot be empty!", { variant: "error" });
      return;
    }
    if (isEditing) {
      setIsLoadingCom(true);
      const formData = new FormData();
      formData.append("text", commentText);
      if (file) {
        formData.append("comment_image", file);
      }
      if (preview) {
        formData.append("is_cancelled", false);
      } else {
        formData.append("is_cancelled", true);
      }

      const result = await update_feed_comment(
        formData,
        editingCommentIndex._id
      );
      if (result.code === 200) {
        setComments((prevComments) =>
          prevComments.map((comment) =>
            comment._id === editingCommentIndex._id ? result?.feed : comment
          )
        );
        setCommentText("");
        setPreview(null);
        setFile("");
        setEmojiPickerVisible(false);
        setIsLoadingCom(false);
        setIsEditing(false);
      } else {
        setIsLoadingCom(false);
      }
    } else {
      setIsLoadingCom(true);
      const formData = new FormData();
      formData.append("feed", post._id);
      formData.append("text", commentText);
      if (file) {
        formData.append("comment_image", file);
      }

      const result = await add_feed_comment(formData);
      if (result.code === 200) {
        setComments([result?.feed_comment, ...comments]);
        setCommentCount(commentCount + 1);

        setFeedComments([result?.feed_comment, ...comments]);
        setLikedComment((prev) => ({
          [0]: false,
          ...Object.fromEntries(
            Object.entries(prev).map(([k, v]) => [parseInt(k) + 1, v])
          ),
        }));
        setCommentsLikeCount((prev) => ({
          [0]: 0,
          ...Object.fromEntries(
            Object.entries(prev).map(([k, v]) => [parseInt(k) + 1, v])
          ),
        }));
        setCommentText("");
        setPreview(null);
        setFile("");
        setEmojiPickerVisible(false);
        setIsLoadingCom(false);
      } else {
        setIsLoadingCom(false);
      }
    }
  };
  const handleAgree = async () => {
    setOpenDelete(false);
    const result = await delete_feed_action(post._id);
    if (result.code === 200) {
      enqueueSnackbar("Post deleted successfully", { variant: "success" });
      getFeedsListingOnDelete(post._id);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleCommentDelete = (selected_comment) => {
    setOpenDeleteComment(true);
    setSelectedComment(selected_comment);
  };

  const handleImageUpload = (event) => {
    if (!event.target?.files || event.target.files.length === 0) {
      console.error("No file selected!");
      return;
    }

    const file = event.target.files[0];
    setFile(file);
    setPreview(URL.createObjectURL(file));

    event.target.value = "";
  };

  const handleOpenImage = (image) => {
    console.log(file, "filefilefile");
    return <a href={image}></a>;
  };

  const handleEditComment = (comment, index) => {
    setIsEditing(true);
    setShowCommentBox(true);
    setEditingCommentIndex(comment);
    setCommentText(comment.text);
    setPreview(comment.comment_image);
  };

  const handleOpenDeatil = () => {
    setOpen(true);
    setPreview(null);
    setCommentText("");
  };
  const handleDialogueOpen = () => {
    setLogoutDialogOpen(true);
  };
  const handleCommentDialogueOpen = () => {
    setCommentDialogue(true);
  };

  const handleComment = () => {
    setCommentDialogue(false);
    // enqueueSnackbar("comment deleted successfully.", { variant: "success" });
  };
  const handleEmojiClick = (emojiData) => {
    console.log(emojiData, "emojiDataemojiDataemojiData");
    setCommentText((prevComment) => prevComment + emojiData.native);
  };

  const handleLogout = () => {
    setLogoutDialogOpen(false);
    // enqueueSnackbar("postpost deleted successfully.", { variant: "success" });
  };

  const handleClose = () => {
    setOpen(false);
    setEmojiPickerVisible(false);
    setComment("");
    setCommentText("");
    setPreview(null);
  };

  const handleClickImage = (event, index, path) => {
    handleSelectedImage(post, index);
    setOpen(true);
    setPreview(null);
    setCommentText("");
  };

  const handleAgreeDelete = (value) => {
    setOpenDelete(true);
  };

  const imageLinks = {
    docx: wordImage,
    mp3: audioImage,
    pdf: pdfImage,
    csv: csvImage,
    doc: docImage,
    xlsx: xlsxImage,
    xls: xlsxImage,
    other: otherImage,
  };
  const getCommentImage = (file) => {
    if (file.type === "file") {
      const ext = file.path.name.split(".").pop();
      if (
        ext == "jpg" ||
        ext == "JPG" ||
        ext == "png" ||
        ext == "webp" ||
        ext == "jpeg" ||
        ext == "JPEG" ||
        ext == "PNG"
      ) {
        return URL.createObjectURL(file.path);
      } else if (imageLinks[ext]) {
        return imageLinks[ext];
      } else {
        return imageLinks.other;
      }
    } else {
      const ext = file.split(".").pop();
      if (
        ext == "jpg" ||
        ext == "JPG" ||
        ext == "png" ||
        ext == "webp" ||
        ext == "jpeg" ||
        ext == "JPEG" ||
        ext == "PNG"
      ) {
        return s3baseUri + file;
      } else if (imageLinks[ext]) {
        return imageLinks[ext];
      } else {
        return imageLinks.other;
      }
    }
  };

  const handleDelete = async () => {
    setOpenDeleteComment(false);
    const result = await delete_comment_api(selectedComment._id);
    if (result.code === 200) {
      setComments((prevComments) =>
        prevComments.filter((comment) => comment._id !== selectedComment._id)
      );
      setCommentCount(commentCount - 1);

      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleMenu = (row) => {
    let MENU_OPTIONS = [];
    MENU_OPTIONS.push({
      label: "Edit",
      icon: "akar-icons:edit",
      handleClick: () => {
        handleFeedEdit(row);
      },
    });

    MENU_OPTIONS.push({
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: handleAgreeDelete,
    });
    return MENU_OPTIONS;
  };

  const handleMenucomments = (row) => {
    let MENU_OPTIONS1 = [];
    MENU_OPTIONS1.push({
      label: "Edit",
      icon: "akar-icons:edit",
      handleClick: () => handleEditComment(row),
    });
    MENU_OPTIONS1.push({
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: () => {
        handleCommentDelete(row);
      },
    });

    return MENU_OPTIONS1;
  };

  // For post creator profile
  const handleCompanyNameClick = () => {
    setCompanyModalData(post?.created_by);
    setCompanyModalOpen(true);
  };
  // For commenter's profile
  const handleCommentCompanyClick = (comment) => {
    setCompanyModalData(comment?.commented_by?._id);
    setCompanyModalOpen(true);
  };

  const handleCloseCompanyModal = () => {
    setCompanyModalOpen(false);
  };

  useEffect(() => {
    if (post.liked_by.length > 0) {
      const isLiked = post.liked_by.some(
        (user) => user._id === userInfo?.user_id?._id
      );
      setLiked(isLiked);
    }
    if (post.top_comments.length > 0) {
      const likedComments = post.top_comments.reduce((acc, item, index) => {
        acc[index] = item.liked_by.some(
          (user) => user._id === userInfo?.user_id?._id
        );
        return acc;
      }, {});

      const likedCounts = post.top_comments.reduce((acc, item, index) => {
        acc[index] = item.liked_by.length;
        return acc;
      }, {});

      setCommentsLikeCount(likedCounts);
      setLikedComment(likedComments);
    }
  }, [post]);
  const parseDescriptionWithLink = (description) => {
    // Regex to match:
    // 1. http://..., https://...
    // 2. www.example.com (but not just "www" alone)
    const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+\.[^\s]{2,})/gi;
    const parts = description.split(urlRegex);

    return parts
      .map((part, index) => {
        if (!part) return null; // Skip empty parts

        // Check if part is a URL (either http(s):// or www.xxx.yyy)
        const isHttpUrl = /^https?:\/\//i.test(part);
        const isWwwUrl = /^www\.[^\s]+\.[^\s]{2,}/i.test(part); // Ensures "www.x.y" format

        if (isHttpUrl || isWwwUrl) {
          const url = isWwwUrl ? `https://${part}` : part; // Add https:// if www. URL
          return (
            <a
              key={index}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1976d2", textDecoration: "underline" }}
              onClick={(e) => e.stopPropagation()}
            >
              {part}
            </a>
          );
        }

        return <span key={index}>{part}</span>;
      })
      .filter(Boolean); // Remove null entries
  };

  let find_create = ids.find((item) => item?._id === post?.created_for);

  // Share URL logic
  const postDetailUrl = `${window.location.origin}/post/${post._id}`;

  // Build a robust share text for all post types
  let shareTextParts = [];
  if (post?.description) shareTextParts.push(post.description);
  if (post?.video_url) shareTextParts.push(`Video: ${post.video_url}`);
  if (post?.image && post.image.length > 0) {
    const imageUrls = post.image.map((img) =>
      img.startsWith("http") ? img : s3baseUri + img
    );
    shareTextParts.push(`Images: ${imageUrls.join(", ")}`);
  }
  if (post?.feed_type === "document" && post?.image?.length > 0) {
    const docUrls = post.image.map((img) =>
      img.startsWith("http") ? img : s3baseUri + img
    );
    shareTextParts.push(`Documents: ${docUrls.join(", ")}`);
  }
  shareTextParts.push(postDetailUrl);

  const [shareAnchorEl, setShareAnchorEl] = useState(null);

  const handleShareClick = (post) => {
    setOpenSharePost(true);
    setSharePostData(post);
  };

  const handleShareClose = () => {
    setShareAnchorEl(null);
  };

  useEffect(() => {
    // Facebook SDK load karein
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: "724262789278150",
        cookie: true,
        xfbml: true,
        version: "v18.0",
      });
    };

    // SDK script load
    const script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    document.head.appendChild(script);
  }, []);

  const sharePopoverOpen = Boolean(shareAnchorEl);

  return (
    <>
      <CustomConfirmation
        openDelete={openDelete}
        setOpenDelete={setOpenDelete}
        title={"Are you sure you want to delete this post?"}
        handleAgree={handleAgree}
      />
      <CustomConfirmation
        openDelete={openDeleteComment}
        setOpenDelete={setOpenDeleteComment}
        title={"Are you sure you want to delete this comment?"}
        handleAgree={handleDelete}
      />
      <Card
        sx={{
          boxShadow: 2,
          mb: 2,
          // maxWidth: 900,
          paddingBottom: "0px",
          marginTop: 0,
          paddingLeft: "0px !important",
          paddingRight: "0px !important",
          paddingTop: "0px !important",
        }}
      >
        <CardContent
          sx={{ paddingBottom: "0px !important", paddingTop: "1px !important" }}
        >
          <div className="row">
            <div className="col-12">
              <Box display="flex" alignItems="center" width="100%">
                <Avatar
                  onClick={handleCompanyNameClick}
                  src={s3baseUri + post?.created_by?.profile_image}
                  sx={{ width: 45, height: 45, mr: 1, cursor: "pointer" }}
                />
                <Box width="100%">
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ marginTop: "12px", cursor: "pointer" }}
                  >
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      sx={{
                        fontSize: "14px",
                        cursor: "pointer",
                        "&:hover": {
                          textDecoration: "underline",
                          color: "#000080",
                        },
                      }}
                      onClick={handleCompanyNameClick}
                    >
                      {post?.created_by?.company_name}
                    </Typography>
                    {userInfo?.user_id?._id ===
                      post?.created_by?.user_id?._id && (
                      <CustomPopover menu={handleMenu(post)} data={comments} />
                    )}
                  </Box>
                  <Typography
                    sx={{ fontSize: "12px", lineHeight: 0.6, marginTop: "2px" }}
                    variant="body2"
                    color="textSecondary"
                  >
                    {show_proper_words(find_create?.title)}
                  </Typography>
                  <Typography
                    sx={{ fontSize: "12px", lineHeight: 0.6 }}
                    variant="caption"
                    color="textSecondary"
                  >
                    {moment(post.published_time).format(
                      "DD MMM YYYY [at] hh:mm A"
                    )}
                  </Typography>
                </Box>
              </Box>
            </div>
            <div className="col-12">
              {linkInDescription ? (
                <>
                  <Typography
                    variant="body1"
                    mt={1}
                    sx={{
                      fontSize: "14px",
                      marginRight: "2px",
                      display: "-webkit-box",
                      WebkitLineClamp: expanded ? "unset" : 3, // Show 3 lines when collapsed
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    onClick={handleOpenDeatil}
                    className="pointer"
                  >
                    {parseDescriptionWithLink(post.description)}
                  </Typography>
                  {post?.description?.length > 150 && ( // Only show toggle if description is long
                    <Typography
                      variant="body2"
                      color="primary"
                      sx={{
                        fontSize: "12px",
                        cursor: "pointer",
                        fontWeight: 500,
                        mt: 0.5,
                        textDecoration: "underline", // Add this line
                      }}
                      onClick={() => setExpanded(!expanded)}
                    >
                      {expanded ? "Read Less" : "Read More"}
                    </Typography>
                  )}
                  {post?.is_link_preview && (
                    <PreviewPostCard
                      text={linkInDescription}
                      type={"icon_close"}
                      post={post}
                      state={false}
                      previewLink={previewLink}
                      setPreviewLink={setPreviewLink}
                      typeData={type}
                    />
                  )}
                </>
              ) : (
                <>
                  <Typography
                    variant="body1"
                    mt={1}
                    sx={{
                      fontSize: "14px",
                      display: "-webkit-box",
                      WebkitLineClamp: expanded ? "unset" : 3,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    onClick={handleOpenDeatil}
                    className="pointer"
                  >
                    {post?.description}
                  </Typography>
                  {post?.description?.length > 150 && (
                    <Typography
                      variant="body2"
                      color="primary"
                      sx={{
                        fontSize: "12px",
                        cursor: "pointer",
                        fontWeight: 500,
                        textDecoration: "underline", // Add this line

                        mt: 0.5,
                      }}
                      onClick={() => setExpanded(!expanded)}
                    >
                      {expanded ? "Read Less" : "Read More"}
                    </Typography>
                  )}
                </>
              )}
            </div>

            <div className={linkInDescription ? "col-12 mt-2" : "col-12"}>
              {post.feed_type === "image" && post.image.length > 0 && (
                <div className="feed-image pointer">
                  <FeedImagesList
                    feed_images={post.image}
                    handleClickImage={handleClickImage}
                  />
                </div>
              )}
              {post?.feed_type === "document" && post?.image?.length > 0 && (
                <div className="feed-image document_img mt-3">
                  {post.image.map((item) => {
                    return (
                      <a
                        target="_blank"
                        href={s3baseUri + item}
                        className="pointer"
                      >
                        <img
                          className="img-fluid"
                          src={getCommentImage(item)}
                        />
                      </a>
                    );
                  })}
                </div>
              )}
              {post.feed_type === "video" && post.video_url && (
                <div className="feed-image mt-3">
                  <ReactVideoPlayer url={post.video_url} />
                </div>
              )}
            </div>
            <div className="col-12">
              <Typography
                sx={{ color: "#00000054", fontSize: "13px", marginLeft: "5px" }}
                variant="body2"
                color="textSecondary"
                mt={2}
              >
                {likeCount} {likeCount > 0 ? "Likes" : "Like"} {commentCount}{" "}
                Comments
              </Typography>
            </div>
            {(userInfo.type === 2 || userInfo.type === 1) && (
              <div className="col-12">
                <div className="d-flex mt-1 like-button">
                  <button
                    onClick={handleLike}
                    style={{
                      border: "none",
                      background: "none",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "0px",
                    }}
                  >
                    {liked ? (
                      <ThumbUpIcon className="thumb-up-icon" />
                    ) : (
                      <ThumbUpAltOutlinedIcon />
                    )}
                    <span style={{ marginLeft: 5, color: "#000000c0" }}>
                      Like
                    </span>
                  </button>
                  <button
                    onClick={
                      userInfo.type === 2 ? handleCommentToggle : undefined
                    }
                    disabled={userInfo.type === 1}
                    style={{
                      border: "none",
                      background: "none",
                      cursor: userInfo.type === 1 ? "not-allowed" : "pointer",
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "0px",
                      opacity: userInfo.type === 1 ? 0.5 : 1,
                    }}
                  >
                    <ChatBubbleOutlineOutlinedIcon />
                    <span style={{ marginLeft: 5, color: "#000000c0" }}>
                      Comment
                    </span>
                  </button>
                  <Tooltip
                    title={
                      !post.description ? "Description required to share" : ""
                    }
                    placement="top"
                    disableHoverListener={!!post.description}
                    arrow
                  >
                    <button
                      onClick={() => handleShareClick(post)}
                      disabled={!post.description}
                      style={{
                        border: "none",
                        background: "none",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "0px",
                      }}
                    >
                      <ShareIcon />
                      <span style={{ marginLeft: 5, color: "#000000c0" }}>
                        Share
                      </span>
                    </button>
                  </Tooltip>

                  <CustomPopoverNew
                    isOpenPop={openSharePost}
                    isClosePop={setOpenSharePost}
                    title="Share Post"
                    width="550px"
                    componentToPassDown={
                      <SharePostPopup postData={sharePostData} />
                    }
                  />
                </div>

                {showCommentBox && userInfo.type === 2 && (
                  <Box p={1} sx={{ borderRadius: 2, paddingTop: "0px" }}>
                    <form onSubmit={handleCommentSubmit}>
                      <TextField
                        rows={2}
                        multiline
                        fullWidth
                        variant="outlined"
                        value={commentText}
                        onChange={(e) => setCommentText(e.target.value)}
                        label={
                          isEditing
                            ? "Edit your comment..."
                            : "Write a comment..."
                        }
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            paddingTop: "5px",
                            paddingBottom: "4px",
                          },
                          "& .MuiOutlinedInput-input": {
                            padding: "4px 8px",
                          },
                        }}
                      />

                      <div className="post-button mt-0">
                        <Box
                          mt={1}
                          display="flex"
                          justifyContent="space-between"
                          sx={{
                            width: "100%",
                            alignItems: "center",
                          }}
                        >
                          <div className="d-flex">
                            {preview && (
                              <div
                                style={{
                                  padding: "4px",
                                  borderRadius: "5px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  maxWidth: "fit-content",
                                  position: "relative",
                                  border: "1px solid #ddd",
                                  background: "#fff",
                                }}
                              >
                                <span
                                  onClick={() => setPreview(null)}
                                  style={{
                                    cursor: "pointer",
                                    background: "red",
                                    color: "white",
                                    borderRadius: "50%",
                                    width: "15px",
                                    height: "15px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "10px",
                                    fontWeight: "bold",
                                    position: "absolute",
                                    top: "-8px",
                                    right: "-8px",
                                    zIndex: 2,
                                    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
                                  }}
                                >
                                  ✖
                                </span>
                                <img
                                  src={
                                    typeof preview === "string" &&
                                    preview.startsWith("blob:")
                                      ? preview
                                      : s3baseUri + preview
                                  }
                                  alt="Preview"
                                  style={{
                                    width: "50px",
                                    height: "50px",
                                    borderRadius: "5px",
                                    objectFit: "cover",
                                    position: "relative",
                                  }}
                                />
                              </div>
                            )}
                            <IconButton component="label">
                              <input
                                type="file"
                                id="imageInput"
                                style={{ display: "none" }}
                                accept="image/*"
                                onChange={handleImageUpload}
                                disabled={userInfo.type === 1}
                              />
                              {!preview && (
                                <AddPhotoAlternateOutlinedIcon
                                  sx={{
                                    color: "#daa520",
                                    opacity: userInfo.type === 1 ? 0.5 : 1,
                                  }}
                                />
                              )}
                            </IconButton>
                          </div>

                          <button
                            className="small-button-cotain-post"
                            type="submit"
                            disabled={isLoadingCom || userInfo.type === 1}
                            style={{
                              width: "100%",
                              maxWidth: "150px",
                              marginTop: { xs: "8px", sm: "0px" },
                              opacity:
                                isLoadingCom || userInfo.type === 1 ? 0.6 : 1,
                              cursor:
                                isLoadingCom || userInfo.type === 1
                                  ? "not-allowed"
                                  : "pointer",
                              pointerEvents:
                                isLoadingCom || userInfo.type === 1
                                  ? "none"
                                  : "auto",
                            }}
                          >
                            {isLoadingCom
                              ? isEditing
                                ? "Updating..."
                                : "Posting..."
                              : isEditing
                              ? "Update"
                              : "Post Comment"}
                          </button>
                        </Box>
                      </div>
                    </form>
                  </Box>
                )}
              </div>
            )}

            <div className="col-12">
              {comments && comments.length > 0 && (
                <Box sx={{ borderRadius: 2 }}>
                  {comments.slice(0, 2).map((comment, index) => {
                    return (
                      <Box
                        key={index}
                        sx={{ borderRadius: 2, paddingBottom: "0px" }}
                        bgcolor="#F1F1F1"
                        p={1}
                        mb={1}
                      >
                        <div className="poster-name-image d-flex w-100 single-comment-card">
                          <Avatar
                            src={
                              s3baseUri + comment?.commented_by?.profile_image
                            }
                            sx={{
                              width: 40,
                              height: 40,
                              mr: 1,
                              cursor: "pointer",
                            }}
                            onClick={() => handleCommentCompanyClick(comment)}
                          ></Avatar>
                          <div className="w-100">
                            <div
                              className="text-start set-title-width poster-name ps-1 w-100 d-flex"
                              style={{
                                justifyContent: "space-between",
                                display: "flex",
                              }}
                            >
                              <Typography
                                variant="h6"
                                fontWeight="bold"
                                sx={{
                                  fontSize: "14px",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                }}
                                onClick={() =>
                                  handleCommentCompanyClick(comment)
                                }
                              >
                                {htmlDecode(comment?.commented_by?.name)}
                              </Typography>
                              <div className="popOver d-flex mt-1">
                                <Typography
                                  className="date-color float-end "
                                  sx={{
                                    fontSize: "12px",
                                    lineHeight: 1,
                                    marginTop: "3px",
                                  }}
                                  color="textSecondary"
                                >
                                  {moment(comment?.createdAt).format(
                                    "DD MMM YYYY [at] hh:mm A"
                                  )}
                                </Typography>

                                {userInfo?.user_id?._id ===
                                  comment?.commented_by?._id && (
                                  <CustomPopover
                                    menu={handleMenucomments(comment)}
                                    data={comment}
                                  />
                                )}
                              </div>
                            </div>
                            <div className="post-description  ps-1">
                              <Typography
                                variant="body2"
                                color="textSecondary"
                                sx={{
                                  fontSize: "12px",
                                  lineHeight: 1.2,
                                  whiteSpace: "pre-line",
                                  wordBreak: "break-word",
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: htmlDecode(comment?.text),
                                }}
                              ></Typography>
                              {comment?.comment_image && (
                                <Box>
                                  <img
                                    onClick={() =>
                                      window.open(
                                        s3baseUri + comment.comment_image,
                                        "_blank"
                                      )
                                    }
                                    src={s3baseUri + comment.comment_image}
                                    alt="Uploaded Comment"
                                    style={{
                                      lineHeight: "0px",
                                      height: "80px",
                                      width: "80px",
                                      borderRadius: "5px",
                                      cursor: "pointer",
                                    }}
                                  />
                                </Box>
                              )}
                              <button
                                onClick={() => {
                                  handleLikeComment(comment, index);
                                }}
                                style={{
                                  border: "none",
                                  background: "none",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  paddingLeft: "0px",
                                  marginTop: "5px",
                                }}
                              >
                                {likedComment[index] ? (
                                  <ThumbUpIcon
                                    style={{
                                      fontSize: "16px",
                                      color: "#000080",
                                    }}
                                  />
                                ) : (
                                  <ThumbUpAltOutlinedIcon
                                    style={{
                                      fontSize: "16px",
                                      color: "#00000054",
                                    }}
                                  />
                                )}
                                <span
                                  style={{
                                    marginLeft: 5,
                                    color: "#000000c0",
                                    fontSize: "12px",
                                  }}
                                >
                                  {commentsLikeCount[index]} Like
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </Box>
                    );
                  })}
                  {commentCount > 2 || comments.length > 2 ? (
                    <Box mt={1} mb={1} display="flex" justifyContent="center">
                      <button
                        className="view-all-btn"
                        onClick={handleOpenDeatil}
                        style={{
                          border: "none",
                          color: "#000080",
                          fontSize: "14px",
                          cursor: "pointer",
                        }}
                      >
                        View more comments
                      </button>
                    </Box>
                  ) : (
                    ""
                  )}
                </Box>
              )}
            </div>
          </div>
          <PostDetalPage
            setCompanyModalData={setCompanyModalData}
            handleCompanyNameClick={handleCompanyNameClick}
            handleCommentCompanyClick={handleCommentCompanyClick}
            companyModalData={companyModalData}
            feedComments={feedComments}
            parseDescriptionWithLink={parseDescriptionWithLink}
            setFeedComments={setFeedComments}
            open={open}
            post={post}
            onClose={handleClose}
            expanded={expanded}
            setExpanded={setExpanded}
            handleMenu={handleMenu}
            handleLike={handleLike}
            liked={liked}
            likeCount={likeCount}
            comments={comments}
            setComment={setComment}
            setComments={setComments}
            setLiked={setLiked}
            handleMenucomments={handleMenucomments}
            isLoadingCom={isLoadingCom}
            setCommentsLikeCount={setCommentsLikeCount}
            selectedImageIndex={selectedIndex}
            commentCount={commentCount}
            commentsLikeCount={commentsLikeCount}
            handleLikeComment={handleLikeComment}
            likedComment={likedComment}
            setLikedComment={setLikedComment}
            handleCommentLike={handleLikeComment}
            handleCommentSubmit={handleCommentSubmit}
            linkInDescription={linkInDescription}
            // feedComments={feedComments}
            // setFeedComments={setFeedComments}
            emojiPickerVisible={emojiPickerVisible}
            setEmojiPickerVisible={setEmojiPickerVisible}
            comment={comment}
            handleEmojiClick={handleEmojiClick}
            handleImageUpload={handleImageUpload}
            preview={preview}
            setPreview={setPreview}
            setCommentText={setCommentText}
            commentText={commentText}
            handleEditComment={handleEditComment}
            setIsEditing={setIsEditing}
            handleFeedEdit={handleFeedEdit}
            isEditing={isEditing}
            handleShareClick={handleShareClick}
          />
        </CardContent>
      </Card>

      {/* Company Profile Modal (for post creator or commenter) */}
      <Modal
        open={companyModalOpen}
        onClose={handleCloseCompanyModal}
        aria-labelledby="company-profile-modal"
        aria-describedby="company-profile-details"
        sx={{
          outline: "none !important",
          boxShadow: "none",
          "& .MuiBackdrop-root": { outline: "none !important" },
          "& .MuiBox-root": {
            outline: "none !important",
          },
          "&:focus": {
            outline: "none !important",
            boxShadow: "none",
            border: "none",
          },
          "&:focus-visible": {
            outline: "none !important",
            boxShadow: "none",
            border: "none",
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "99vw", sm: 1400, md: 1600, lg: 1800 },
            maxWidth: 1200,
            height: "auto",
            maxHeight: "97vh",
            bgcolor: "#fff",
            borderRadius: 3,
            boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
            overflow: "hidden",
            p: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Fixed header */}
          <Box
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 10,
              background: "linear-gradient(90deg, #000080 0%, #3a3a90 100%)",
              color: "white",
              px: 4,
              py: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              boxShadow: "0 2px 12px rgba(0,0,0,0.10)",
              minHeight: 56,
            }}
          >
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{ letterSpacing: 1, fontSize: 20 }}
            >
              Company Profile
            </Typography>
            <IconButton onClick={handleCloseCompanyModal}>
              <CloseIcon style={{ color: "#fff" }} />
            </IconButton>
          </Box>
          {/* Scrollable content below header, no horizontal scroll */}
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              overflowY: "auto",
              overflowX: "hidden",
              p: 0,
            }}
          >
            <Box className="container-fluid" sx={{ p: 2 }}>
              <Box className="row">
                <Box className="col-12 mt-3">
                  <Box
                    className="card shadow-md p-4 "
                    sx={{ borderRadius: 3, mb: 0 }}
                  >
                    <Box className="row g-4">
                      <Box className="col-md-6">
                        <Box className="d-flex">
                          <Box className="heading-main container mb-4 ">
                            <Typography
                              variant="h5"
                              fontWeight="bold"
                              className="fw-bold mb-2 "
                            >
                              {/* Show name, company, and comment id if present */}
                              {companyModalData?.company_name ||
                                companyModalData?.name ||
                                "N/A"}
                            </Typography>
                          </Box>
                        </Box>
                        <Divider />
                        <Box
                          className="info-section detail-page-text"
                          sx={{
                            wordWrap: "break-word",
                            overflow: "hidden",
                            maxWidth: "100%",
                          }}
                        >
                          {/* Social Links Section */}

                          {/* Show all info, including comment text, sector, etc. */}
                          <p style={{ marginBottom: 0 }}>
                            <strong>Name</strong>{" "}
                            <span className="text-muted ms-4">
                              {companyModalData?.name ||
                                companyModalData?.company_name ||
                                "N/A"}
                            </span>
                          </p>
                          <Divider />

                          <Divider />
                          <p style={{ marginBottom: 0 }}>
                            <strong>Sector</strong>{" "}
                            <span className="text-muted ms-4">
                              {companyModalData?.sector ||
                                companyModalData?.sector ||
                                "N/A"}
                            </span>
                          </p>
                          <Divider />
                          <p style={{ marginBottom: 0 }}>
                            <strong>Location</strong>{" "}
                            <span className="text-muted ms-4">
                              {companyModalData?.location || "N/A"}
                            </span>
                          </p>
                          <Divider />
                          <p style={{ marginBottom: 0 }}>
                            <strong>Website</strong>{" "}
                            {companyModalData?.website ? (
                              <a
                                href={companyModalData?.website}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-primary ms-4 pointer"
                                style={{ wordBreak: "break-word" }}
                              >
                                {companyModalData?.website}
                              </a>
                            ) : (
                              <span>no data</span>
                            )}
                          </p>
                          <Divider />
                          <p style={{ marginBottom: 0 }}>
                            <strong>Contact Number</strong>{" "}
                            <span className="text-muted ms-4">
                              {companyModalData?.contact_number || "N/A"}
                            </span>
                          </p>
                          <Divider />
                          <p style={{ marginBottom: 0 }}>
                            <strong>Email</strong>{" "}
                            <span className="text-muted ms-4">
                              {companyModalData?.email ||
                                companyModalData?.user_id?.email ||
                                "N/A"}
                            </span>
                          </p>
                          <Divider />
                          {companyModalData?.social_links && (
                            <Box sx={{ mb: 2 }}>
                              <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
                                {companyModalData.social_links.facebook && (
                                  <a
                                    href={
                                      companyModalData.social_links.facebook
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <FaFacebook size={22} color="#4267B2" />
                                  </a>
                                )}
                                {companyModalData.social_links.instagram && (
                                  <a
                                    href={
                                      companyModalData.social_links.instagram
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <FaInstagram size={22} color="#000" />
                                  </a>
                                )}
                                {companyModalData.social_links.linkedin && (
                                  <a
                                    href={
                                      companyModalData.social_links.linkedin
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <FaLinkedin size={22} color="#000" />
                                  </a>
                                )}
                                {companyModalData.social_links.twitter && (
                                  <a
                                    href={companyModalData.social_links.twitter}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <FaTwitter size={22} color="#000" />
                                  </a>
                                )}
                                {companyModalData.social_links.youtube && (
                                  <a
                                    href={companyModalData.social_links.youtube}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <FaYoutube size={22} color="#000" />
                                  </a>
                                )}
                              </Box>
                            </Box>
                          )}
                        </Box>
                      </Box>
                      <Box className="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-center align-items-center">
                        {companyModalData?.profile_image ? (
                          <img
                            src={s3baseUri + companyModalData?.profile_image}
                            alt={
                              companyModalData?.company_name ||
                              companyModalData?.name
                            }
                            className="rounded-3 shadow-sm img-fluid"
                            style={{ maxHeight: 260, objectFit: "cover" }}
                          />
                        ) : (
                          <RecordNoImage title="No Image Available" />
                        )}
                      </Box>
                    </Box>
                    {companyModalData?.about && (
                      <Box
                        className="card shadow-md p-4 mt-3 mb-1 about-content"
                        sx={{ borderRadius: 3 }}
                      >
                        <Typography
                          variant="h5"
                          fontWeight="bold"
                          className="fw-bold mb-4 ps-2"
                        >
                          About
                        </Typography>
                        <Typography
                          className="ps-2 ckeditor-content"
                          sx={{ color: "#444", fontSize: 16 }}
                          component="div"
                          dangerouslySetInnerHTML={{
                            __html: companyModalData?.about,
                          }}
                        />
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default PostCard;
